<template>
  <header class="c-header">
    <a class="c-header__link" :href="plusUrl">
      <div class="c-header__body">
        <BrandLogo />
        <ABody class="c-header__a-body" size="small"
          >次のキャリアが見える、転職サイト</ABody
        >
      </div>
    </a>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BrandLogo from '@/assets/images/svg/brandLogo.vue';
import ABody from '@/components/atoms/ATypography/ABody/index.vue';

export default defineComponent({
  name: 'CHeader',
  components: {
    BrandLogo,
    ABody
  },
  data() {
    return {
      HeaderLogo: require('@/assets/images/svg/brand-logo.svg'),
      plusUrl: process.env['VUE_APP_ONECAREER_PLUS_ORIGIN']
    };
  }
});
</script>

<style lang="scss" scoped>
.c-header {
  display: flex;
  align-items: center;
  height: 78px;
  padding: 0 24px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

  @include mq() {
    justify-content: center;
    height: 45px;
    font-size: 14px;
  }

  &__body {
    display: flex;
    align-items: center;
  }

  &__a-body {
    margin-left: 24px;

    @include mq {
      display: none;
    }
  }

  &__link {
    text-decoration: none;
  }
}
</style>
